var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopmate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5186 9.26627C18.9051 7.5788 17.7417 6.14678 16.2157 5.20063C14.6896 4.25447 12.8897 3.84919 11.1054 4.04999C9.32112 4.2508 7.65627 5.04601 6.37871 6.30768C5.10116 7.56936 4.28518 9.22413 4.06208 11.0058C3.83897 12.7874 4.2217 14.5923 5.1487 16.13C6.07569 17.6678 7.49305 18.8489 9.17271 19.4835C10.8524 20.1181 12.6967 20.1692 14.4089 19.6285C16.1211 19.0879 17.6017 17.987 18.6124 16.5029L12.0001 11.9998L19.5186 9.26627Z",
    fill: "#888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopmate);
export default __webpack_public_path__ + "static/media/topmate.7c98bc173e15aad00fa9b9a7cfd6b92e.svg";
export { ForwardRef as ReactComponent };